(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const bar = document.currentScript && document.currentScript.previousElementSibling;
    const root = document.querySelector('.countdown-bar');
    if (!root) return;

    const hours = parseFloat(root.dataset.durationHours || '0');
    const minutes = parseFloat(root.dataset.durationMinutes || '0');
    const durationMs = Math.max(1000, (hours * 3600 + minutes * 60) * 1000);
    const storageKey = 'bisous_countdown_end_' + durationMs;

    const elDays = root.querySelector('[data-days]');
    const elHours = root.querySelector('[data-hours]');
    const elMinutes = root.querySelector('[data-minutes]');
    const elSeconds = root.querySelector('[data-seconds]');

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function getEndTime() {
      let end = parseInt(localStorage.getItem(storageKey) || '0', 10);
      const now = Date.now();
      if (!end || end <= now) {
        end = now + durationMs;
        localStorage.setItem(storageKey, String(end));
      }
      return end;
    }

    function tick() {
      const end = getEndTime();
      let diff = end - Date.now();
      if (diff < 0) diff = 0;

      const days = Math.floor(diff / 86400000);
      const hrs = Math.floor((diff % 86400000) / 3600000);
      const mins = Math.floor((diff % 3600000) / 60000);
      const secs = Math.floor((diff % 60000) / 1000);

      elDays.textContent = pad(days);
      elHours.textContent = pad(hrs);
      elMinutes.textContent = pad(mins);
      elSeconds.textContent = pad(secs);
    }

    tick();
    setInterval(tick, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
